import React, { useId, useCallback } from 'react';
import styles from './knob.module.css';

export function Knob({
  isEnabled = false,
  onChange = () => {},
  disabled = false,
  className = '',
  label = '',
  id = ''
}) {
  const reactId = useId();
  const inputId = id || `knob-${reactId}`;

  const handleToggle = useCallback(() => {
    if (!disabled) {
      onChange();
    }
  }, [disabled, onChange]);

  const handleKeyDown = (e) => {
    if (disabled) return;
    if (e.key === ' ' || e.key === 'Enter') {
      e.preventDefault();
      handleToggle();
    } else if (e.key === 'ArrowRight') {
      e.preventDefault();
      if (!isEnabled) onChange();
    } else if (e.key === 'ArrowLeft') {
      e.preventDefault();
      if (isEnabled) onChange();
    }
  };

  return (
    <div
      className={`${styles.knob} ${disabled ? styles['knob--disabled'] : ''} ${className}`}
      data-disabled={disabled || undefined}
    >
      {label && (
        <label htmlFor={inputId} className={styles.knob__label}>
          {label}
        </label>
      )}

      {/* Input ascuns pentru accesibilitate/native semantics */}
      <input
        id={inputId}
        type="checkbox"
        checked={isEnabled}
        disabled={disabled}
        onChange={handleToggle}
        className={styles.knob__input}
        aria-checked={isEnabled}
        role="switch"
      />

      <div
        className={`${styles.knob__track} ${isEnabled ? styles['knob__track--enabled'] : ''} ${disabled ? styles['knob__track--disabled'] : ''}`}
        tabIndex={disabled ? -1 : 0}
        onClick={handleToggle}
        onKeyDown={handleKeyDown}
        aria-hidden="true"
      >
        <div className={styles.knob__thumb}>
          {/* Show check when enabled; otherwise if disabled show a small circle indicator */}
          {isEnabled ? (
            <svg
              className={styles.knob__checkIcon}
              viewBox="0 0 12 12"
              fill="none"
              aria-hidden="true"
              focusable="false"
            >
              <path
                d="M10 3L4.5 8.5L2 6"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ) : disabled ? (
            <svg
              className={styles.knob__disabledIcon}
              viewBox="0 0 12 12"
              fill="none"
              aria-hidden="true"
              focusable="false"
            >
              <circle cx="6" cy="6" r="4" stroke="currentColor" strokeWidth="2" />
            </svg>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default Knob;
